import {
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
    OnDestroy,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AvanceTrabajoDTO } from "app/main/apps/shared/interfaces/avance-trabajo.interface";
import { OrdenesDeTrabajoService } from "app/main/apps/shared/services/rest/ordenes-de-trabajo.service";

import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { DialogUbicacionComponent } from "../dialog-ubicacion/dialog-ubicacion.component";
import { ImagenesOOTTComponent } from "../imagenes-oott/imagenes-oott.component";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { finalize } from "rxjs/operators";
import { Subscription } from "rxjs";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";

@Component({
    selector: "app-dialog-avance-trabajo",
    templateUrl: "./dialog-avance-trabajo.component.html",
    styleUrls: ["./dialog-avance-trabajo.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogAvanceTrabajoComponent implements OnInit, OnDestroy {
    avances: AvanceTrabajoDTO[];
    subscripciones: Subscription;
    constructor(
        public dialogRef: MatDialogRef<DialogAvanceTrabajoComponent>,
        private _dialogSrvc: DialogService,
        @Inject(MAT_DIALOG_DATA)
        public data: { idTrabajo: number; idOOTT: number },
        private _oottSrvc: OrdenesDeTrabajoService,
        private _fuseProgressBarService: FuseProgressBarService,
        public _menuUsuarioSrvc: MenuUsuarioService
    ) {
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {
        //console.log(this.data);
        setTimeout(() => {
            this._fuseProgressBarService.show();
        });
        this.subscripciones.add(
            this._oottSrvc
                .fetchAvanceTrabajo(this.data.idTrabajo)
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe((resp) => (this.avances = resp))
        );
    }

    verImagenes(idsFotos: number[]) {
        //console.log(idsFotos);
        this._dialogSrvc.abrirDialog(
            ImagenesOOTTComponent,
            "clase-dialog-imagenes-trabajo",
            "800px",
            { idsFotos }
        );
    }

    verUbicacion(avance: AvanceTrabajoDTO) {
        this._dialogSrvc.abrirDialog(
            DialogUbicacionComponent,
            "clase-dialog",
            "800px",
            {
                avance,
            }
        );
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
